export default "__VITE_ASSET__BWhp0yoQ__"